let runState = [
  [
    {name: "离线", color: "red"},
    {name: "在线", color: "green"}
  ],
  [
    {name: "关屏", color: "red"},
    {name: "开屏", color: "green"}
  ],
  [
    {name: "停播", color: "red"},
    {name: "在播", color: "green"}
  ],
  [
    {name: "无下载项", color: "red"},
    {name: "下载中", color: "green"}
  ]
];
let stateColor = ['#ea1a1a', '#00ae00', '#b68167'];

export function runStateInfo(deviceState, groupState) {
  deviceState = Number(deviceState);
  groupState = Number(groupState);
  let length = runState.length;
  let result = {
    stateName: [],
    stateColor: stateColor[0]
  };
  if (groupState) {
    for (let i = 0; i < length; i++) {
      let bit = Math.pow(2, i);
      let isTrue = Boolean(bit & deviceState);
      // console.log(`${bit}&${deviceState}---->`, isTrue);
      if (i === 0 && !isTrue) {
        result = {
          stateName: [runState[0][0].name],
          stateColor: stateColor[0]
        };
        break;
      } else {
        if (i === 3) {
          isTrue && result.stateName.push(runState[i][1].name);
        } else {
          result.stateName.push(runState[i][isTrue ? 1 : 0].name);
        }
        result.stateColor = stateColor[1];
      }
    }
  } else {
    result.stateName.push('受限');
    result.stateColor = stateColor[2];
    for (let i = 1; i < length; i++) {
      let bit = Math.pow(2, i);
      let isTrue = Boolean(bit & deviceState);
      if (i === 3) {
        isTrue && result.stateName.push(runState[i][1].name);
      } else {
        result.stateName.push(runState[i][isTrue ? 1 : 0].name);
      }
    }
  }
  // console.log("result---->", result);
  result.stateName = result.stateName.join("&");
  return result;
}
